<template>
  <div class="content-container profile-page e2fa-page">
    <div class="page-wrap">
      <div class="page-content clearfix">
        <Form @submit="verify" v-if="store.qrCode">
          <div class="main-content f-left">
            <div class="row-sec">
              <div class="title-holder t-center"><h4>{{$t("enable_2fa.title")}}</h4></div>
              <div class="content-holder t-center">
                <div class="img-holder"><img src="assets/images/lock-ico.png" alt="" /></div>
                <p>{{$t("enable_2fa.description")}}</p>
                <div class="qr-code"><img :src="store.qrCode" alt="" /></div>
              </div>
              <div class="form-holder">
                <ul>
                  <li>
                    <label for="">{{$t("enable_2fa.google_authenticator_code")}}<span style="color: #d43737;">*</span></label>
                    <Field autocomplete="off" name="google_token" v-model="google_token" rules="required|min:6|max:6|numeric" />
                    <ErrorMessage name="google_token" />
                  </li>
                </ul>
                <div class="note">
                  <p><strong>{{$t("enable_2fa.how_to_enable")}}</strong></p>
                  <p>
                    1. {{$t("enable_2fa.download")}} <strong>{{$t("enable_2fa.google_authenticator_app")}}</strong> {{$t("enable_2fa.on_mobile_tablet")}} <br />
                    2. {{$t("enable_2fa.scan_the")}} <strong>{{$t("enable_2fa.qr_code")}}</strong> {{$t("enable_2fa.appearing_above")}}. <br />
                    3. {{$t("enable_2fa.enter_the")}} <strong>{{$t("enable_2fa.passcode")}}</strong> {{$t("enable_2fa.appers_in_google_auth_app")}}. <br />
                    4. {{$t("enable_2fa.click_on_the_button")}}<strong>“{{$t("enable_2fa.click_to_enable")}}”</strong>.
                  </p>
                </div>
              </div>
            </div>
            <div class="btn-holder t-center"><button type="submit" class="btn btn-yellow popup-link-holder">{{$t("enable_2fa.click_to_enable")}}</button></div>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      google_token: "",
      submitted : false,
      enabled2fa: false
    };
  },
  components: { Form, Field, ErrorMessage },
  mounted(){
    this.submit()
  },
  methods: {
    submit() {
      this.store.generate2FA({}, true);
    },
    verify() {
      this.store.verify2FA({ google_token: this.google_token }, true, this);
      // this.google_token = "";
    }
  },
};
</script>